import { EditOutlined } from '@ant-design/icons'
import { Button, Table } from 'antd'
import { ColumnType } from 'antd/es/table'
import { useState } from 'react'

import { useClassifierServiceGetListInvestigationTestTypeEndpoint } from 'src/api/queries'
import { InvestigationTestTypeItemDto } from 'src/api/requests'
import { PageBreadcrumbs } from 'src/components'
import { useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'

import { InvestigationTemplateModal } from '../components'

export const InvestigationTemplates = () => {
  const { t, currentLang } = useLocales()

  const pagination = useTablePagination()

  const [isOpen, setIsOpen] = useState(false)
  const [currentId, setCurrentId] = useState<string>()
  const [testType, setTestType] = useState<string>()

  const { data, isLoading } =
    useClassifierServiceGetListInvestigationTestTypeEndpoint({
      pageNumber: Number(pagination.current),
      pageSize: Number(pagination.pageSize)
    })

  const columns: ColumnType<InvestigationTestTypeItemDto>[] = [
    {
      key: 'title',
      title: t('tests_results.type'),
      render: (_, { title }) => title?.[currentLang.value]
    },
    {
      key: 'actions',
      render: ({ id, title }) => (
        <Button
          icon={<EditOutlined />}
          onClick={() => {
            setCurrentId(id)
            setIsOpen(true)
            setTestType(title?.[currentLang.value])
          }}
        >
          {t('common.edit')}
        </Button>
      )
    }
  ]

  const onModalClose = () => {
    onToggle()
    setTestType(undefined)
    setCurrentId(undefined)
  }

  const onToggle = () => setIsOpen((prev) => !prev)

  return (
    <PageBreadcrumbs
      title={t('menu.investigation_templates')}
      items={[{ title: t('menu.investigation_templates') }]}
    >
      <Table
        rowKey="id"
        loading={isLoading}
        columns={columns}
        dataSource={data?.data}
        scroll={{ x: 'max-content' }}
        pagination={{ ...pagination, total: data?.totalCount }}
      />

      {isOpen && (
        <InvestigationTemplateModal
          onCancel={onModalClose}
          id={currentId}
          testType={testType}
        />
      )}
    </PageBreadcrumbs>
  )
}
